import { schema } from 'normalizr'
import reservationElement from './reservationElement'

const reservationList = new schema.Entity('reservationLists', {
  reservation_elements: [reservationElement],
})

export default reservationList
